import React from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AddListingInitializeType } from '~addListing/types';

const ReferenceNumber = ({
  setValue,
}: {
  setValue: UseFormSetValue<AddListingInitializeType>;
}) => {
  const { t } = useTranslation('app');

  return (
    <div className="flex flex-col gap-2x">
      <p className="text-title_4 flex gap-x">
        <span>{t('referenceNumber')}</span>
        <span className="text-body_1 text-gray__dark_2">({t('optional')})</span>
      </p>
      <input
        placeholder={t('enterReferenceNumberText')}
        className="border border-gray h-[40px] px-1.5x rounded-[12px]"
        onChange={(e) => setValue('referenceNumber', e.target.value)}
      />
    </div>
  );
};

export default ReferenceNumber;
